<template>
  <div>

    <!-- Header -->
    <header class="site-header" :class="{ scrolled: scrolled }">
      <div class="nav-bar">
        <div class="nav-logo">
          <div class="logo-icon"><img src="../assets/imgs/logos.png" alt="暖心尾货回收" /></div>
          <div>
            暖心尾货回收
            <div class="logo-sub">尾货回收·变现金</div>
          </div>
        </div>
        <!--
        <nav class="nav-links">
          <a @click="scrollTo('recovery-types')">回收类型</a>
          <a @click="scrollTo('categories')">尾货类型</a>
          <a @click="scrollTo('testimonials')">同行评价</a>
          <a @click="scrollTo('guide')">变现指南</a>
          <a @click="scrollTo('products')">好货导购</a>
          <a @click="scrollTo('compare')">利润对比</a>
        </nav>-->
        <div class="nav-actions">
          <button class="nav-cta" @click="openPurchases()">立即回收</button>
          <button class="nav-cta outline" @click="openPurchase">立即拿货</button>
        </div>
        <button class="nav-hamburger" @click="mobileMenu = !mobileMenu" :class="{ active: mobileMenu }" aria-label="菜单">
          <span></span><span></span><span></span>
        </button>
      </div>
      <div class="nav-mobile-menu" :class="{ show: mobileMenu }">
        <!--
        <a @click="scrollTo('recovery-types'); mobileMenu = false">回收类型</a>
        <a @click="scrollTo('categories'); mobileMenu = false">尾货类型</a>
        <a @click="scrollTo('testimonials'); mobileMenu = false">同行评价</a>
        <a @click="scrollTo('guide'); mobileMenu = false">变现指南</a>
        <a @click="scrollTo('products'); mobileMenu = false">好货导购</a>
        <a @click="scrollTo('compare'); mobileMenu = false">利润对比</a>-->
        <div class="nmm-btns">
          <button class="nav-cta" @click="openPurchases(); mobileMenu = false">立即回收</button>
          <button class="nav-cta outline" @click="openPurchase(); mobileMenu = false">立即拿货</button>
        </div>
      </div>
    </header>

    <!-- Hero -->
    <section id="hero" class="hero">
      <div class="hero-inner">
        <div class="hero-left">
          <div class="hero-badge animate__animated animate__fadeIn">⚠️ 中间商 / 二手贩子 / 倒爷 勿扰</div>
          <h1 class="animate__animated animate__fadeInUp">尾货回收 · <span class="grad">变废为宝</span><br>让库存变成现金流</h1>
          <p class="sub animate__animated animate__fadeInUp">
            工厂悔单货、外贸退单件、电商定制退单货、工厂余单（微瑕产品），商场实体店电商专柜撤柜库存产品，全品类精准收购。上门验货，现金结算。</p>
          <div class="hero-btns animate__animated animate__fadeInUp">
            <button class="hero-btn primary" @click="openSubmitRes()">📦 提交尾货信息</button>
            <button class="hero-btn ghost" @click="scrollTo('recovery-types')">浏览类型</button>
            <button class="hero-btn primary" @click="openSubmitResAbout()">关于我们</button>
          </div>
        </div>
        <div class="hero-right animate__animated animate__fadeIn">
          <div class="hero-card">
            <h3>⚡ 快速估价通道</h3>
            <div class="hc-item">
              <div class="hc-icon c1">🏭</div>
              <div class="hc-text">
                <h4>工厂悔单货</h4>
                <p>取消订单/生产过剩</p>
              </div>
            </div>
            <div class="hc-item">
              <div class="hc-icon c2">🌍</div>
              <div class="hc-text">
                <h4>外贸退单件</h4>
                <p>出口退单/检验不合格</p>
              </div>
            </div>
            <div class="hc-item">
              <div class="hc-icon c3">📦</div>
              <div class="hc-text">
                <h4>电商定制退单货</h4>
                <p>退换货/定制取消</p>
              </div>
            </div>
            <div class="hc-item">
              <div class="hc-icon c4">🔍</div>
              <div class="hc-text">
                <h4>工厂余单（微瑕）</h4>
                <p>轻微瑕疵/尾货回收</p>
              </div>
            </div>
            <div class="hc-item">
              <div class="hc-icon c5">🏬</div>
              <div class="hc-text">
                <h4>商场实体店电商专柜撤柜库存</h4>
                <p>撤柜库存/品牌下架</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="hero-stats animate__animated animate__fadeInUp">
        <div class="hero-stat">
          <div class="hs-num">50+</div>
          <div class="hs-label">收购品类</div>
        </div>
        <div class="hero-stat">
          <div class="hs-num">10000+</div>
          <div class="hs-label">服务商家</div>
        </div>
        <div class="hero-stat">
          <div class="hs-num">5000万+</div>
          <div class="hs-label">回收金额</div>
        </div>
        <div class="hero-stat">
          <div class="hs-num">98%</div>
          <div class="hs-label">好评率</div>
        </div>
      </div>
    </section>

    <!-- ════════════════════════════════════════════ -->
    <!-- Part 1: 尾货回收                              -->
    <!-- ════════════════════════════════════════════ -->
    <div class="part-divider g1">
      <div class="pd-badge"><span class="pd-num">1</span> 📦 尾货回收 · 让积压库存变现金</div>
    </div>

    <!-- 回收类型 4项 -->
    <section id="recovery-types" class="section rtype-section">
      <div class="section-head animate__animated animate__fadeInUp">
        <span class="sh-tag">源头直收</span>
        <h2>尾货回收 · <span class="grad">五大货源类型</span></h2>
        <p>只接一手货源，精准识别尾货来源，源头直收价格更优</p>
      </div>
      <div class="rtype-grid">
        <div class="rtype-card animate__animated animate__fadeInUp" v-for="(rt, idx) in recoveryTypes" :key="rt.id"
          :style="{ animationDelay: idx * 0.08 + 's' }">
          <div class="rtype-icon" :class="'bg' + ((idx % 4) + 1)">{{ rt.icon }}</div>
          <h3>{{ rt.title }}</h3>
          <p class="rt-desc">{{ rt.desc }}</p>
          <span class="rtype-tag">{{ rt.tag }}</span>
        </div>
      </div>
    </section>

    <!-- 尾货类型 6项 -->
    <section id="categories" class="section cat-section">
      <div class="section-head animate__animated animate__fadeInUp">
        <span class="sh-tag">品类全覆盖</span>
        <h2>尾货类型 · <span class="grad">六大品类精准收购</span></h2>
        <p>无论您是工厂、品牌方还是电商卖家，我们都能快速评估、高效收购</p>
      </div>
      <div class="cat-grid">
        <div class="cat-card animate__animated animate__fadeInUp" v-for="(cat, idx) in categories" :key="cat.id"
          :style="{ animationDelay: idx * 0.08 + 's' }">
          <div class="cat-icon" :class="'bg' + ((idx % 6) + 1)">{{ cat.icon }}</div>
          <h3>{{ cat.title }}</h3>
          <p class="cat-desc">{{ cat.desc }}</p>
          <div class="cat-tags">
            <span v-for="tag in cat.tags" :key="tag.name" :class="{ hot: tag.hot }">{{ tag.name }}</span>
          </div>
        </div>
      </div>
    </section>

    <!-- 勿扰声明
    <div class="noban">
      <div class="noban-inner animate__animated animate__fadeInUp">
        <div class="noban-icon">🚫</div>
        <div class="noban-text">
          <h4>源头直收 · 中间商/二手贩子/倒爷勿扰</h4>
          <p>本平台只接一手货源，谢绝中间商加价转手，确保源头商家利益最大化</p>
        </div>
        <div class="noban-tags">
          <span>中间商勿扰</span>
          <span>二手贩子勿扰</span>
          <span>倒爷勿扰</span>
        </div>
      </div>
    </div>-->
    <section class="section partner-section">
      <div class="section-head animate__animated animate__fadeInUp">
        <span class="sh-tag">同行信赖</span>
        <h2>同行都在合作 · <span class="grad">实力见证</span></h2>
        <p>数千家工厂、品牌方、电商卖家选择暖心尾货回收，高效变现库存</p>
      </div>
      <div class="partner-row animate__animated animate__fadeInUp">
        <div class="partner-chip" v-for="p in partners" :key="p.name">
          <div class="pc-icon">{{ p.icon }}</div>
          <span>{{ p.name }}</span>
        </div>
      </div>
      <div class="partner-stats animate__animated animate__fadeInUp">
        <div class="ps-card" v-for="s in partnerStats" :key="s.label">
          <div class="ps-num">{{ s.num }}</div>
          <div class="ps-label">{{ s.label }}</div>
        </div>
      </div>
    </section>

    <!-- 他们怎么说 -->
    <section id="testimonials" class="section test-section">
      <div class="section-head animate__animated animate__fadeInUp">
        <span class="sh-tag">真实评价</span>
        <h2>他们怎么说 · <span class="grad">商家真实反馈</span></h2>
        <p>听听合作过的工厂负责人、品牌方、电商卖家怎么说</p>
      </div>
      <div class="test-grid">
        <div class="test-card animate__animated animate__fadeInUp" v-for="(t, idx) in testimonials" :key="t.id"
          :style="{ animationDelay: idx * 0.1 + 's' }">
          <div class="test-quote">"</div>
          <p class="test-text">{{ t.text }}</p>
          <div class="test-author">
            <div class="test-avatar">{{ t.avatar }}</div>
            <div class="test-info">
              <h4>{{ t.name }}</h4>
              <p>{{ t.role }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 采购流程 -->
    <section id="process" class="section proc-section">
      <div class="section-head animate__animated animate__fadeInUp">
        <span class="sh-tag">高效回收</span>
        <h2>采购流程 · <span class="grad">简单高效五步走</span></h2>
        <p>从询价到结算，五步完成全流程，现金即时到账</p>
      </div>
      <div class="proc-steps">
        <div class="proc-step animate__animated animate__fadeInUp" v-for="(step, idx) in processSteps" :key="idx"
          :style="{ animationDelay: idx * 0.1 + 's' }">
          <div class="proc-num">{{ idx + 1 }}</div>
          <h4>{{ step.title }}</h4>
          <p>{{ step.desc }}</p>
        </div>
      </div>
    </section>

    <!-- 六大保障 -->
    <section class="section trust-section">
      <div class="section-head animate__animated animate__fadeInUp">
        <span class="sh-tag">安心托付</span>
        <h2>四大保障 · <span class="grad">安心托付</span></h2>
        <p>专业团队、透明流程，让每一笔交易都放心无忧</p>
      </div>
      <div class="trust-grid">
        <div class="trust-card animate__animated animate__fadeInUp" v-for="(t, idx) in trustBadges" :key="idx"
          :style="{ animationDelay: idx * 0.08 + 's' }">
          <div class="trust-icon">{{ t.icon }}</div>
          <div>
            <h4>{{ t.title }}</h4>
            <p>{{ t.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 勿扰声明 -->
    <div class="noban" id="noban">
      <div class="noban-inner animate__animated animate__fadeInUp">
        <div class="noban-icon">🚫</div>
        <div class="noban-text">
          <h4>源头直收 · 中间商/二手贩子/倒爷勿扰</h4>
          <p>本平台只接一手货源，谢绝中间商加价转手，确保源头商家利益最大化</p>
        </div>
        <div class="noban-tags">
          <span>中间商勿扰</span>
          <span>二手贩子勿扰</span>
          <span>倒爷勿扰</span>
        </div>
      </div>
    </div>

    <!-- 立刻联系我们 CTA -->
    <div id="cta-banner" class="cta-banner">
      <div class="cta-inner animate__animated animate__fadeInUp">
        <div class="cta-text">
          <h2>有尾货要处理？立刻联系我们</h2>
          <p>免费上门验货 · 透明报价 · 现金结算</p>
        </div>
        <div class="cta-btns">
          <button class="cta-btn primary" @click="scrollTo('footer')">扫码联系</button>
          <!--
          <button class="cta-btn ghost" @click="scrollTo('guide')">更多合作</button>-->
          <button class="cta-btn ghost" @click="openPurchase()">立即回收</button>
        </div>
      </div>
    </div>

    <!-- ════════════════════════════════════════════ -->
    <!-- Part 2: 尾货采购货源变现                       -->
    <!-- ════════════════════════════════════════════ -->
    <div class="part-divider g2">
      <div class="pd-badge"><span class="pd-num">2</span> 💰 尾货采购货源变现 · 商家变现指南</div>
    </div>

    <!-- 商家变现指南 -->
    <section id="guide" class="section guide-section">
      <div class="section-head animate__animated animate__fadeInUp">
        <span class="sh-tag">实战选品分析</span>
        <h2>地摊和电商与实体店 · <span class="grad">好卖爆款产品分析</span></h2>
        <p>地摊·电商·实体店三大渠道好卖爆款产品深度文章分析，选品逻辑·定价策略·实操案例一网打尽</p>
      </div>
      <div class="guide-grid">
        <div class="guide-card animate__animated animate__fadeInUp" v-for="(g, idx) in guides" :key="g.id"
          :style="{ animationDelay: idx * 0.1 + 's' }" @click="openGuide(g)">
          <div class="guide-cover">
            <img :src="g.image_input[0]" :alt="g.title">
            <span class="guide-type text">
              <template>📝 文字</template>
            </span>
          </div>
          <div class="guide-body">
            <h3>{{ g.title }}</h3>
            <p>{{ g.synopsis }}</p>
            <div class="guide-meta">
              <span>{{ g.author }}</span>
              <span>·</span>
              <span>10万+ 阅读</span>
            </div>
            <div class="guide-read">阅读全文 →</div>
          </div>
        </div>
      </div>
      <!-- 变现指南分页 -->
      <div class="guide-pagination">
        <el-pagination background @current-change="guidesChangesPage" :current-page="guidePage"
          :page-size="guidePageSize" layout="total,prev,pager,next" :total="guidesTotal">
        </el-pagination>
      </div>
    </section>

    <!-- 尾货好物 超值导购 -->
    <section id="products" class="section prod-section">
      <div class="section-head animate__animated animate__fadeInUp">
        <span class="sh-tag">超值导购</span>
        <h2>尾货好物 · <span class="grad">超值导购</span></h2>
        <p>精选尾货好物，点击 自动轮播，点击查看详情扫码下单</p>
      </div>
      <div class="prod-tabs">
        <button class="prod-tab" :class="{ active: prodTab === 'all' }" @click="changeProdTab('all')">全部好物</button>
        <button class="prod-tab" :class="{ active: prodTab === 'clothing' }" @click="changeProdTab('clothing')">👕
          服装鞋包</button>
        <button class="prod-tab" :class="{ active: prodTab === 'daily' }" @click="changeProdTab('daily')">🧴
          日用</button>
        <button class="prod-tab" :class="{ active: prodTab === 'beauty' }" @click="changeProdTab('beauty')">💄
          美妆</button>
        <button class="prod-tab" :class="{ active: prodTab === 'home' }" @click="changeProdTab('home')">🏠
          家居</button>
        <button class="prod-tab" :class="{ active: prodTab === 'toy' }" @click="changeProdTab('toy')">🎮
          潮玩</button>
      </div>
      <div class="prod-grid">
        <div class="prod-card animate__animated animate__fadeInUp" :class="{ presale: p.presale === '1' }"
          v-for="(p, idx) in products" :key="p.id" :style="{ animationDelay: idx * 0.06 + 's' }"
          @mouseenter="startProdHover(p.id)" @mouseleave="stopProdHover(p.id)">
          <div class="prod-img">
            <div class="prod-img-track" :style="{ transform: 'translateX(-' + getCardImgIdx(p.id) * 100 + '%)' }">
              <div class="prod-img-slide" v-for="(img, i) in p.slider_image" :key="i">
                <img :src="img" :alt="p.name">
              </div>
            </div>
            <span class="prod-badge" :class="p.badgeType" v-if="p.badge">{{ p.badge }}</span>
            <button class="prod-img-arrow prev" @click.stop="cardImgPrev(p.id)" v-if="p.slider_image.length > 1">
              <svg viewBox="0 0 24 24">
                <polyline points="15 6 9 12 15 18" />
              </svg>
            </button>
            <button class="prod-img-arrow next" @click.stop="cardImgNext(p.id)" v-if="p.slider_image.length > 1">
              <svg viewBox="0 0 24 24">
                <polyline points="9 6 15 12 9 18" />
              </svg>
            </button>
            <div class="prod-img-dots" v-if="p.slider_image.length > 1">
              <span class="prod-img-dot" :class="{ active: getCardImgIdx(p.id) === i }"
                v-for="(img, i) in p.slider_image" :key="i" @click.stop="setCardImgIdx(p.id, i)"></span>
            </div>
          </div>
          <div class="prod-body">
            <h3>{{ p.store_name }}</h3>
            <p class="pd-desc">{{ p.store_info }}</p>
            <div class="prod-presale-info" v-if="p.presale == '1'">
              <span class="ppi-icon">🔮</span><span>预售商品 · 预计3天内发货</span>
            </div>
            <div class="prod-tags">
              <span v-for="tag in p.tags" :key="tag">{{ tag }}</span>
            </div>
            <div class="prod-price-row">
              <div>
                <span class="prod-price">¥{{ p.price }}<small>起</small></span>
                <span class="prod-old">¥{{ p.ot_price }}</span>
              </div>
              <button class="prod-buy" @click="openProduct(p)">{{ p.presale == '1' ? '立即预订' : '立即购买'
              }}</button>
            </div>
          </div>
        </div>
      </div>
      <!-- 分页 -->
      <div class="prod-pagination">
        <el-pagination background @current-change="prosChangesPage" :current-page="prodPage" :page-size="pageSize"
          layout="total,prev,pager,next" :total="prodTotal">
        </el-pagination>
      </div>
    </section>

    <!-- 中间商采购 vs 源头直采 利润对比 -->
    <section id="compare" class="section compare-section">
      <div class="section-head animate__animated animate__fadeInUp">
        <span class="sh-tag">利润对比</span>
        <h2>中间商采购 <span class="grad">PK</span> 源头直采</h2>
        <p>同样一批尾货，选对渠道利润翻倍</p>
      </div>
      <div class="compare-grid animate__animated animate__fadeInUp">
        <div class="compare-card middleman">
          <div class="compare-badge">中间商采购</div>
          <h3>⚠️ 中间商转手</h3>
          <div class="compare-row"><span class="cr-label">拿货价</span><span class="cr-value">高 30-50%</span></div>
          <div class="compare-row"><span class="cr-label">利润率</span><span class="cr-value">100-150%</span></div>
          <div class="compare-row"><span class="cr-label">货源真实性</span><span class="cr-value">无法保障</span></div>
          <div class="compare-row"><span class="cr-label">品质把控</span><span class="cr-value">层层加价</span></div>
          <div class="compare-row"><span class="cr-label">售后支持</span><span class="cr-value">无保障</span></div>
          <div class="compare-row"><span class="cr-label">起批量</span><span class="cr-value">小批量可拿</span></div>
        </div>
        <div class="compare-vs">VS</div>
        <div class="compare-card direct">
          <div class="compare-badge">源头直采 ✓</div>
          <h3>✅ 源头直采</h3>
          <div class="compare-row"><span class="cr-label">拿货价</span><span class="cr-value">最低源头价</span></div>
          <div class="compare-row"><span class="cr-label">利润率</span><span class="cr-value">200-400%</span></div>
          <div class="compare-row"><span class="cr-label">货源真实性</span><span class="cr-value">工厂直供</span></div>
          <div class="compare-row"><span class="cr-label">品质把控</span><span class="cr-value">源头验货</span></div>
          <div class="compare-row"><span class="cr-label">售后支持</span><span class="cr-value">全程保障</span></div>
          <div class="compare-row"><span class="cr-label">起批量</span><span class="cr-value">大批量更优</span></div>
        </div>
      </div>
    </section>
    <!-- 博主采购视频记录 -->
    <section id="vlog" class="section vlog-section" v-if="vlogs.length > 0">
      <div class="section-head animate__animated animate__fadeInUp">
        <span class="sh-tag">采购实拍</span>
        <h2>博主采购 · <span class="grad">视频记录</span></h2>
        <p>真实博主到仓采购实拍，从验货到装车全程记录，看完放心下单</p>
      </div>
      <div class="vlog-grid">
        <div class="vlog-card animate__animated animate__fadeInUp" v-for="(v, idx) in vlogs" :key="v.id"
          :style="{ animationDelay: idx * 0.06 + 's' }" @click="openVlog(v)">
          <div class="vlog-thumb">
            <img :src="v.image_input[0]" :alt="v.title" loading="lazy">
            <span class="vlog-badge">视频</span>
            <div class="vlog-play">
              <svg viewBox="0 0 24 24">
                <path d="M8 5v14l11-7z" />
              </svg>
            </div>
            <span class="vlog-duration">+</span>
          </div>
          <div class="vlog-body">
            <div class="vlog-blogger">
              <div>
                <div class="vlog-blogger-name">{{v.author}}</div>
                <div class="vlog-blogger-tag">{{v.catename}}</div>
              </div>
            </div>
            <h3 class="vlog-title">{{ v.title }}</h3>
            <div class="vlog-meta">
              <span>▶ 10万+</span>
              <span>👍 1000+</span>
              <span>{{ v.add_time }}</span>
            </div>
            <div class="vlog-tags">
              <span>{{v.catename}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 分页 -->
      <div class="prod-pagination">
        <el-pagination background @current-change="vlogsChangesPage" :current-page="vlogPage" :page-size="vlogPageSize"
          layout="total,prev,pager,next" :total="vlogTotal">
        </el-pagination>
      </div>
    </section>

    <!-- Vlog Video Modal -->
    <div class="vlog-modal-overlay" v-if="vlogModal" @click.self="closeVlog" style="animation:fadeIn .3s">
      <div class="vlog-modal-box">
        <div class="vlog-modal-header">
          <h3>{{ currentVlog.title }}</h3>
          <button class="vlog-modal-close" @click="closeVlog">✕</button>
        </div>
        <div class="vlog-modal-video">
          <video :src="currentVlog.video_link" controls autoplay playsinline :poster="currentVlog.poster"
            style="width:100%;max-height:480px"></video>
        </div>
        <div class="vlog-modal-info">
          <div class="vlog-modal-blogger">
            <div>
              <div class="vlog-blogger-name" style="color:#fff">{{ currentVlog.author }}</div>
              <div class="vlog-blogger-tag">{{ currentVlog.catename }}</div>
            </div>
          </div>
          <p class="vlog-modal-desc">{{ currentVlog.synopsis }}</p>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <footer id="footer" class="site-footer">
      <div class="footer-inner">
        <div class="footer-grid">
          <div class="footer-col">
            <div class="footer-brand">
              <!---
              <div class="logo-icon">♻️</div>-->
              <div>
                <span>暖心尾货服务平台</span>
                <div class="logo-sub">尾货回收·变现金</div>
              </div>
            </div>
            <p class="footer-desc">暖心尾货服务平台专注尾货回收与货源变现，源头直收、精准收购、现金结算。助力工厂清仓变现，帮助商家低成本拿货盈利。</p>
            <p class="footer-slogan">让每一件尾货都有价值 💰</p>
          </div>
          <div class="footer-col footer-contact">
            <h4>联系我们</h4>
            <p>微信号:<strong>SoSunLive16168</strong></p>
            <p>📱 <strong><a style="display: inline-block;" href="tel:17005865066">17005865066</a></strong></p>
            <p>📧 3556676671@qq.com</p>
            <p>📍 全国范围上门验货收购，江浙沪优先（台州，宁波，温州，绍兴，金华，杭州，上海）</p>
            <p>🕐 周一至周日 8:00-22:00</p>
          </div>
          <div class="footer-col">
            <h4>扫码添加</h4>
            <div class="footer-qr-row">
              <div class="footer-qr-card">
                <div class="qr-box">
                  <img src="../../public/imgs/qrcode_for.jpg" width="100%" height="auto"></img>
                  <div class="qr-icon gh">📢</div>
                </div>
                <h5>(暖心小生活Life)尾货服务平台公众号</h5>
                <p>尾货回收 / 拿货平台</p>
              </div>
              <div class="footer-qr-card">
                <div class="qr-box">
                  <img src="../../public/imgs/wx-code.jpg" width="100%" height="auto"></img>
                  <div class="qr-icon wx">💚</div>
                </div>
                <h5>暖心尾货服务商务合作微信</h5>
                <p>收购合作 / 尾货拿样客服联系</p>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <p>© 2026 暖心尾货服务平台 · 让积压库存变现金 · 备案在线合法经营 · 诚信生意 · 保留所有权利</p>
          <p class="footer-icp"><a href="https://beian.miit.gov.cn/">浙ICP备17001033号-1</a></p>
          <p class="footer-icp"><a href="https://beian.mps.gov.cn/#/query/webSearch">浙公网安备33108202000960号</a></p>
        </div>
      </div>
    </footer>

    <!-- Float Buttons -->
    <div class="float-contact">
      <div class="float-btn wx" @click="scrollTo('footer')" title="商务合作微信">💬</div>
      <div class="float-btn top" @click="scrollTo('hero')" title="回到顶部">↑</div>
    </div>

    <!-- Guide Modal -->
    <div class="modal-overlay" :class="{ show: guideModal }" @click.self="closeGuide">
      <div class="modal-box" v-if="currentGuide" style="position:relative">
        <button class="modal-close" @click="closeGuide">✕</button>
        <img class="modal-cover" :src="currentGuide.image_input[0]" />
        <div class="modal-body">
          <span class="modal-type text">
            <template>📝 文字攻略</template>
          </span>
          <h2>{{ currentGuide.title }}</h2>
          <div class="modal-meta">
            <span>✍️ {{ currentGuide.author }}</span>
            <span>📅 {{ currentGuide.add_time }}</span>
            <span>👁️ 10万+ 阅读</span>
          </div>
          <div class="modal-content" v-html="currentGuide.content"></div>
          <div class="modal-cta">
            <p>💡 觉得有用？扫码添加商务微信，获取更多尾货变现攻略</p>
            <button @click="closeGuide(); scrollTo('footer')">扫码联系 →</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Product Detail Modal -->
    <div class="prod-modal-overlay" :class="{ show: prodModal }" @click.self="closeProduct">
      <div class="prod-modal-box" :class="{ presale: currentProduct && currentProduct.badgeType === 'presale' }"
        v-if="currentProduct" style="position:relative">
        <button class="modal-close" @click="closeProduct">✕</button>
        <div class="pm-carousel">
          <div class="pm-track" :style="{ transform: 'translateX(-' + prodDetailIdx * 100 + '%)' }">
            <div class="pm-slide" v-for="(img, i) in pmImages" :key="i">
              <img :src="img" :alt="currentProduct.name">
            </div>
          </div>
          <button class="prod-img-arrow prev" @click.stop="prodDetailPrev" v-if="pmImages.length > 1" aria-label="上一张">
            <svg viewBox="0 0 24 24">
              <polyline points="15 6 9 12 15 18" />
            </svg>
          </button>
          <button class="prod-img-arrow next" @click.stop="prodDetailNext" v-if="pmImages.length > 1" aria-label="下一张">
            <svg viewBox="0 0 24 24">
              <polyline points="9 6 15 12 9 18" />
            </svg>
          </button>
          <div class="prod-img-dots" v-if="pmImages.length > 1">
            <span class="prod-img-dot" :class="{ active: prodDetailIdx === i }" v-for="(img, i) in pmImages" :key="i"
              @click.stop="prodDetailIdx = i"></span>
          </div>
        </div>
        <div class="pm-body">
          <h2>{{ currentProduct.store_name }}</h2>
          <div class="pm-price-row">
            <span class="pm-price">¥{{ currentProduct.price }}<small style="font-size:14px;font-weight:600">
                起</small></span>
            <span class="pm-old">原价 ¥{{ currentProduct.ot_price }}</span>
          </div>
          <p class="pm-desc">{{ currentProduct.store_info }}</p>
          <div class="prod-presale-info" v-if="currentProduct.presale == '1'" style="margin-bottom:20px">
            <span class="ppi-icon">🔮</span><span>预售商品 · 预计3天内发货 · 先到先得</span>
          </div>
          <div class="pm-tags">
            <span v-for="tag in currentProduct.tags" :key="tag">{{ tag }}</span>
          </div>
          <div class="pm-qr">
            <div class="pm-qr-box">
                <img src="../../public/imgs/qrcode_for.jpg" width="100%" height="auto">
            </div>
            <div class="pm-qr-info">
              <h4 v-if="currentProduct.presale == '1'">🛒 扫码预订购买</h4>
              <h4 v-else>🛒 扫码联系购买</h4>
              <p v-if="currentProduct.presale == '1'">长按识别二维码 → 添加商务微信 → 预付定金下单</p>
              <p v-else>长按识别二维码 → 添加商务微信 → 咨询下单</p>
              <span class="pm-qr-tip" v-if="currentProduct.presale == '1'">✓ 预售专属 · 先到先得</span>
              <span class="pm-qr-tip" v-else>✓ 尾货正品 · 品质保障</span>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="purchase-overlay" :class="{ show: purchaseModals }" @click.self="closePurchase">
      <div class="purchase-box">
        <div class="purchase-decor"></div>
        <button class="modal-close" @click="closePurchase" style="position:absolute;top:18px;right:18px">✕</button>
        <div class="purchase-glyph">
          <img src="../../public/imgs/wx-code.jpg" alt="公众号图标" />
        </div>
        <div class="purchase-title">添加暖心尾货服务平台商务微信（添加备注尾货回收）</div>
        <div class="purchase-subtitle">尾货回收详情沟通</div>
        <div class="purchase-tip">
          扫描页面底部，添加商务微信，详聊
        </div>
        <div class="purchase-btns">
          <button class="purchase-btn ghost" @click="closePurchase">我知道了</button>
        </div>
      </div>
    </div>

    <!-- Purchase Tip Modal -->
    <div class="purchase-overlay" :class="{ show: purchaseModal }" @click.self="closePurchase">
      <div class="purchase-box">
        <div class="purchase-decor"></div>
        <button class="modal-close" @click="closePurchase" style="position:absolute;top:18px;right:18px">✕</button>
        <div class="purchase-glyph">
          <img src="../../public/imgs/qrcode_for.jpg" alt="公众号图标" />
        </div>
        <div class="purchase-title">(暖心小生活Life)尾货服务平台公众号</div>
        <div class="purchase-subtitle">尾货回收 / 拿货平台</div>
        <div class="purchase-glyph">
          <img src="../../public/imgs/wx-code.jpg" alt="公众号图标" />
        </div>
        <div class="purchase-title">添加商务微信</div>
        <div class="purchase-subtitle">回收拿货客服实时详情沟通</div>
        <div class="purchase-tip">
          扫描页面底部 <strong>(暖心小生活Life)尾货服务平台公众号</strong> 二维码<br>
          或添加商务微信，进入<strong>拿货平台</strong>了解更多货源
        </div>
        <div class="purchase-btns">
          <button class="purchase-btn primary" @click="closePurchase(); scrollTo('footer')">去关注公众号</button>
          <button class="purchase-btn ghost" @click="closePurchase">我知道了</button>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import ApiCon from "../util/Api/index"

export default {
  name: "index",
  data() {
    return {
      scrolled: false,
      mobileMenu: false,
      prodTab: 'all',
      prodPage: 1,
      pageSize: 12,
      prodTotal: 1,
      guideModal: false,
      guidePage: 1,
      guidePageSize: 3,
      guidesTotal: 1,
      prodModal: false,
      purchaseModal: false,
      purchaseModals: false,
      prodDetailIdx: 0,
      prodDetailTimer: null,
      currentGuide: null,
      currentProduct: null,
      cardImgIdx: {},
      prodImgTimers: {},
      fbImgIdx: {},
      fbTimers: {},
      vlogPage: 1,
      vlogTotal: 1,
      vlogPageSize: 6,
      vlogModal: false,
      currentVlog: null,
      recoveryTypes: [
        { id: 1, icon: '🏭', title: '工厂悔单货', desc: '工厂取消订单、生产过剩、客户悔单等产生的全新库存，源头直收。', tag: '一手货源' },
        { id: 2, icon: '🌍', title: '外贸退单件', desc: '出口订单退单、检验不合格、外商取消订单等外贸尾货，品质有保障。', tag: '出口品质' },
        { id: 3, icon: '📦', title: '电商定制退单货', desc: '电商平台退换货、定制款取消、退货积压等，按批次整体收购。', tag: '整批收购' },
        { id: 4, icon: '🔍', title: '工厂余单（微瑕产品）', desc: '轻微瑕疵品、尾货回收、样衣样版等，低价收购高性价比。', tag: '低价高性价比' },
        { id: 5, icon: '🏬', title: '商场实体店电商专柜撤柜库存产品', desc: '商场专柜撤柜库存回收、品牌下架、季节性撤柜等，品牌品质尾货精选收购。', tag: '品牌品质' }
      ],
      categories: [
        { id: 1, icon: '👕', title: '服装服饰', desc: '换季清仓、过季款、库存积压的男装、女装、童装、运动服等全品类服装尾货。', tags: [{ name: '男装' }, { name: '女装' }, { name: '童装' }, { name: '运动服', hot: true }] },
        { id: 2, icon: '🧴', title: '日用百货', desc: '洗护用品、纸品、清洁用品、一次性用品等日用百货尾货，临期停产均可收购。', tags: [{ name: '洗护' }, { name: '纸品', hot: true }, { name: '清洁' }] },
        { id: 3, icon: '💄', title: '美妆护体', desc: '护肤、彩妆、洗护、口腔护理等美妆个护类尾货，临期/停产/包装更新均可。', tags: [{ name: '护肤', hot: true }, { name: '彩妆' }, { name: '洗护' }] },
        { id: 4, icon: '🏠', title: '家居家电用品', desc: '厨房用品、收纳用品、装饰摆件、家用电器、电子数码、家纺布艺等家居类尾货，大批量优先。', tags: [{ name: '厨具' }, { name: '收纳' }, { name: '家电' }, { name: '家纺', hot: true }] },
        { id: 5, icon: '👟', title: '鞋子箱包', desc: '运动鞋、拖鞋、皮鞋、帆布鞋、双肩包、手提包等鞋包类尾货，品牌尾单更优。', tags: [{ name: '运动鞋', hot: true }, { name: '皮鞋' }, { name: '箱包' }] },
        { id: 6, icon: '🎮', title: '潮玩解压', desc: '潮玩手办、解压玩具、盲盒、文创周边等潮玩类尾货，年轻群体热销。', tags: [{ name: '手办', hot: true }, { name: '解压玩具' }, { name: '盲盒' }] }
      ],
      partners: [
        { icon: '🏭', name: '服装加工厂' },
        { icon: '🌍', name: '外贸出口商' },
        { icon: '📦', name: '电商平台卖家' },
        { icon: '🏷️', name: '品牌方' },
        { icon: '🏪', name: '实体连锁店' },
        { icon: '🚚', name: '物流仓储商' },
        { icon: '🧴', name: '日化工厂' },
        { icon: '👟', name: '鞋包制造商' }
      ],
      partnerStats: [
        { num: '10000+', label: '合作商家' },
        { num: '5000万+', label: '回收金额' },
        { num: '50+', label: '收购品类' },
        { num: '98%', label: '好评率' }
      ],
      testimonials: [
        { id: 1, avatar: '👨‍🏭', name: '张厂长', role: '服装加工厂负责人', text: '换季积压2000多件库存，暖心尾货回收当天上门验货现金结算，比中间商多卖了40%。源头直收果然不一样。' },
        { id: 2, avatar: '👩‍💼', name: '李经理', role: '外贸出口公司', text: '一批出口退单件本以为要亏本处理，结果暖心尾货回收按品质分级收购，价格比预期高很多，很专业。' },
        { id: 3, avatar: '🧑‍💻', name: '王总', role: '电商品牌方', text: '退货积压占满仓库，联系暖心尾货回收后整批清走，现金即时到账，释放仓储空间又回笼资金。' }
      ],
      vlogs: [
     
      ],
      processSteps: [
        { title: '在线询价', desc: '微信/电话提交尾货信息' },
        { title: '上门验货', desc: '专业团队预约上门验货' },
        { title: '批量样品', desc: '现场拿样品' },
        { title: '商家验货', desc: '好货不怕检验' },
        { title: '批量下单', desc: '批量下单源头采购' }
      ],
      trustBadges: [
        { icon: '✅', title: '品质保障', desc: '专业验货，品质透明不欺瞒' },
        { icon: '📍', title: '上门服务', desc: '全国范围上门验货收购，江浙沪优先（台州，宁波，温州，绍兴，金华，杭州，上海）' },
        { icon: '🔒', title: '隐私保护', desc: '商家信息严格保密' },
        { icon: '🚚', title: '批量采购', desc: '源头批量下单采购' }
      ],
      guides: [],
      cate_id: '',
      products: []
    };
  },
  components: {

  },
  filters: {

  },
  computed: {
    pmImages: function () {
      if (!this.currentProduct) return [];
      if (this.currentProduct.slider_image && this.currentProduct.slider_image.length) {
        return this.currentProduct.slider_image;
      }
      return this.currentProduct.slider_image ? [this.currentProduct.slider_image] : [];
    }
  },
  mounted: function () {
    var self = this;
    self.getProductLists()
    self.getArticleLists()
    self.getArticleListVlogs()
    this.products.forEach(function (p) {
      self.$set(self.cardImgIdx, p.id, 0);
    });
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy: function () {
    window.removeEventListener('scroll', this.handleScroll);
    if (this.smsTimer) clearInterval(this.smsTimer);
    this.stopProdDetailAuto();
    var self = this;
    Object.keys(this.prodImgTimers).forEach(function (id) {
      clearInterval(self.prodImgTimers[id]);
    });
    Object.keys(this.fbTimers).forEach(function (id) {
      clearInterval(self.fbTimers[id]);
    });
  },
  methods: {
    openSubmitRes() {
      let self = this
      self.$router.push("/SubmitRes/1");
    },
     openSubmitResAbout() {
      let self = this
      self.$router.push("/SubmitRes/2");
    },
    changeProdTab(val) {
      let self = this
      self.prodTab = val
      if (self.prodTab == 'all') {
        self.cate_id = ''
      } else if (self.prodTab == 'clothing') {
        self.cate_id = '8'
      } else if (self.prodTab == 'daily') {
        self.cate_id = '3'
      } else if (self.prodTab == 'beauty') {
        self.cate_id = '7'
      } else if (self.prodTab == 'home') {
        self.cate_id = '4'
      } else if (self.prodTab == 'toy') {
        self.cate_id = '42'
      }
      self.prodPage = 1
      self.getProductLists()
    },
    getProductLists() {
      self.prodPage = 1
      this.$api.mall
        .getGoodList({
          page: 1,
          cate_id: this.cate_id,
          limit: 12,
        })
        .then((res) => {
          this.products = res.data.list
          this.prodTotal = res.data.count
        });
    },
    prosChangesPage(e) {
      this.prodPage = e
      this.$api.mall
        .getGoodList({
          page: e,
          cate_id: this.cate_id,
          limit: 12,
        })
        .then((res) => {
          this.products = res.data.list
          this.prodTotal = res.data.count
        });
    },
    getArticleListVlogs() {
      this.$api.mall.getArticleList({ id: 1, page: 1, limit: 18 })
        .then((res) => {
          this.vlogs = res.data.list
          this.vlogTotal = res.data.count
        });
    },
    vlogsChangesPage(e){
      this.vlogPage = e
      this.$api.mall.getArticleList({ id: 2, page: e, limit: 18 })
        .then((res) => {
          this.vlogs = res.data.list
          this.vlogTotal = res.data.count
        });
    },
    getArticleLists() {
      this.$api.mall.getArticleList({ id: 2, page: 1, limit: 18 })
        .then((res) => {
          this.guides = res.data.list
          this.guidesTotal = res.data.count
        });
    },
    guidesChangesPage(e) {
      this.guidePage = e
      this.$api.mall.getArticleList({ id: 2, page: e, limit: 18 })
        .then((res) => {
          this.guides = res.data.list
          this.guidesTotal = res.data.count
        });
    },
    handleScroll: function () {
      this.scrolled = window.scrollY > 20;
    },
    scrollTo: function (id) {
      var el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    openGuide: function (g) {
      this.currentGuide = g;
      this.guideModal = true;
      document.body.style.overflow = 'hidden';
    },
    closeGuide: function () {
      this.guideModal = false;
      document.body.style.overflow = '';
      var self = this;
      setTimeout(function () { self.currentGuide = null }, 300);
    },
    openProduct: function (p) {
      this.currentProduct = p;
      this.prodDetailIdx = 0;
      this.prodModal = true;
      document.body.style.overflow = 'hidden';
      var self = this;
      this.$nextTick(function () {
        self.startProdDetailAuto();
      });
    },
    closeProduct: function () {
      this.prodModal = false;
      document.body.style.overflow = '';
      this.stopProdDetailAuto();
      var self = this;
      setTimeout(function () { self.currentProduct = null }, 300);
    },
    /* ── Product Detail Carousel ── */
    prodDetailPrev: function () {
      var len = this.pmImages.length;
      if (!len) return;
      this.prodDetailIdx = (this.prodDetailIdx - 1 + len) % len;
    },
    prodDetailNext: function () {
      var len = this.pmImages.length;
      if (!len) return;
      this.prodDetailIdx = (this.prodDetailIdx + 1) % len;
    },
    startProdDetailAuto: function () {
      this.stopProdDetailAuto();
      if (this.pmImages.length <= 1) return;
      var self = this;
      this.prodDetailTimer = setInterval(function () {
        if (!self.currentProduct) return;
        var len = self.pmImages.length;
        if (len <= 1) {
          self.stopProdDetailAuto();
          return;
        }
        self.prodDetailIdx = (self.prodDetailIdx + 1) % len;
      }, 3000);
    },
    stopProdDetailAuto: function () {
      if (this.prodDetailTimer) {
        clearInterval(this.prodDetailTimer);
        this.prodDetailTimer = null;
      }
    },
    openPurchases: function () {
      this.purchaseModals = true;
      document.body.style.overflow = 'hidden';
    },
    /* ── Purchase Tip ── */
    openPurchase: function () {
      this.purchaseModal = true;
      document.body.style.overflow = 'hidden';
    },
    closePurchase: function () {
      this.purchaseModal = false;
      this.purchaseModals = false;
      document.body.style.overflow = '';
    },
    getCardImgIdx: function (id) {
      return this.cardImgIdx[id] || 0;
    },
    setCardImgIdx: function (id, idx) {
      this.$set(this.cardImgIdx, id, idx);
    },
    cardImgPrev: function (id) {
      var p = this.products.find(function (x) { return x.id === id });
      if (!p) return;
      var len = p.slider_image.length;
      var cur = this.cardImgIdx[id] || 0;
      this.$set(this.cardImgIdx, id, (cur - 1 + len) % len);
    },
    cardImgNext: function (id) {
      var p = this.products.find(function (x) { return x.id === id });
      if (!p) return;
      var len = p.slider_image.length;
      var cur = this.cardImgIdx[id] || 0;
      this.$set(this.cardImgIdx, id, (cur + 1) % len);
    },
    startProdHover: function (id) {
      var self = this;
      if (this.prodImgTimers[id]) clearInterval(this.prodImgTimers[id]);
      this.prodImgTimers[id] = setInterval(function () {
        var p = self.products.find(function (x) { return x.id === id });
        if (!p || p.slider_image.length <= 1) return;
        var cur = self.cardImgIdx[id] || 0;
        self.$set(self.cardImgIdx, id, (cur + 1) % p.slider_image.length);
      }, 2500);
    },
    stopProdHover: function (id) {
      if (this.prodImgTimers[id]) {
        clearInterval(this.prodImgTimers[id]);
        this.prodImgTimers[id] = null;
      }
    },
    /* ── Vlog Video ── */
    openVlog: function (v) {
      this.currentVlog = v;
      this.vlogModal = true;
      document.body.style.overflow = 'hidden';
    },
    closeVlog: function () {
      this.vlogModal = false;
      document.body.style.overflow = '';
      var self = this;
      setTimeout(function () { self.currentVlog = null }, 300);
    },
    vlogPrevPage: function () {
      if (this.vlogPage > 1) this.vlogPage--;
    },
    vlogNextPage: function () {
      if (this.vlogPage < this.vlogTotalPages) this.vlogPage++;
    }
  },
};
</script>

<style lang='scss' scoped>
* {
  padding: 0px;
  margin: 0px;
  box-sizing: border-box
}
</style>
